var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"paginationDom",staticClass:"sy-pagination"},[(_vm.hasMore)?_c('div',{staticClass:"loading-indicator"},[_c('div',{staticClass:"loading-spinner"}),_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.showText))])]):_c('div',{staticClass:"no-more-text"},[_c('span',[_vm._v(_vm._s(_vm.showText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }